export const viewModes = {
	MODE_PLACE: 'place',
	MODE_INVITATIONS: 'invitations',
	MODE_INVITATIONS_SENT: 'invitations_sent',
	MODE_INVITATIONS_RECEIVED: 'invitations_received',
};
